import * as o from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/Chats.es.js";
const t = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...a, weights: s }));
t.displayName = "ChatsIcon";
const n = t;
export {
  n as Chats,
  t as ChatsIcon
};
